var scope_0 = require('/Users/blainelewis/projects/blainelewis1.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/42a56d1caece8c0cec429036ad353b11.js').default;
var scope_1 = require('/Users/blainelewis/projects/blainelewis1.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/50c32ef520a99a7f1249b8db4d576d50.js').default;
var scope_2 = require('/Users/blainelewis/projects/blainelewis1.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    